export default "__VITE_ASSET__IA9fbKU6__"